import { Size } from '@ps/web-core-enums';
import { StarsButton, useScreenSize } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router';

import { useWidget } from '@swf/core/hooks/useWidget';
import type { Dispatch } from '@swf/core/store';

import { ModalRoutes } from '../../../../types/common';
import type { CreateClubSuccessParams } from '../../../MyClubs/CreateClub/components/CreateClubSuccess/CreateClubSuccess';
import useGetClubPassword from '../../hooks/useGetClubPassword';

import { TXTCLI_Share, TXTWCL_Share_Club } from './ShareButton.messages.json';
import styles from './ShareButton.scss';
import ShareIcon from './assets/share.svg';

const ShareButton: React.FC = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const { modal } = useDispatch<Dispatch>();
  const { widgetId } = useWidget();
  const { clubPassword } = useGetClubPassword(Number(clubId));
  const { greaterThan } = useScreenSize();

  const handleClick = () => {
    if (clubPassword) {
      const locationState: CreateClubSuccessParams = {
        clubId: Number(clubId),
        invitationCode: clubPassword,
        ignoreDataFetch: true,
        title: TXTWCL_Share_Club,
        widgetId
      };
      modal.enqueue({
        path: ModalRoutes.createClubSuccess,
        locationState
      });
    }
  };

  return (
    <StarsButton
      className={styles.button}
      variant="text"
      onClick={handleClick}
      translation={greaterThan(Size.Small) ? TXTCLI_Share : undefined}
      icon={<ShareIcon />}
    />
  );
};

export default ShareButton;
